import React from 'react';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import { Grid } from '@mui/joy';
import ActionButton from '../../../../Components/custom_components/CustomButtons/ActionButton/ActionButton';
import CustomTextFieldWithIcon from '../../../../Components/custom_components/custom_text_field/CustomTextFieldWithIcon';
import CustomTextArea from '../../../../Components/custom_components/CustomTextArea/CustomTextArea';
import { FaHashtag } from 'react-icons/fa';
import './InvoiceFormStyle.css';

function InvoiceForm({ handleSave, formValues, isButtonDisabled = false, isDisabled = false, selectedIds }) {

    const formik = useFormik({
        initialValues: formValues,
        validationSchema: Yup.object({
            invoiceNumber: Yup.string().required('Invoice number is required'),
            description: Yup.string().required('Description is required'),
            amount: Yup.number()
                .typeError('Amount must be a number')
                .required('Amount is required')
                .moreThan(0, 'Amount must be positive')
                .max(9999999.99, 'Amount must be less than or equal to 9,999,999.99')
                .test(
                    'valid-format',
                    'Enter a valid AED amount (max 7 digits before and 2 after decimal)',
                    (value) => {
                        if (value === undefined || value === null) return false;
                        const regex = /^\d{1,7}(\.\d{1,2})?$/;
                        return regex.test(value.toString());
                    }
                )
        }),
        enableReinitialize: true,
        onSubmit: (values) => {
            const destrcturedData = {
                Id: JSON.stringify(selectedIds),
                ID_InvoiceNumber: values?.invoiceNumber,
                amount: values?.amount,
                description: values?.description,
            }
            handleSave(destrcturedData);
        },
    });

    const handleReset = () => {
        formik.resetForm();
    };
    return (
        <div className="invoice-form-container">
            <Grid container spacing={2}>
                {/* Invoice Number Field */}
                <Grid item xs={12} md={6}>
                    <div className="invoice-form-mid-container">
                        <div className="invoice-label-container">
                            <span className="invoice-label">
                                Invoice Number<span className="invoice-required-remark">*</span>
                            </span>
                        </div>
                        <div className="invoice-custom-textfield-container">
                            <CustomTextFieldWithIcon
                                id="invoiceNumber"
                                name="invoiceNumber"
                                placeholder="Enter invoice number"
                                value={formik?.values?.invoiceNumber}
                                onChange={formik.handleChange}

                                onBlur={formik.handleBlur}
                                error={formik.touched.invoiceNumber && Boolean(formik.errors.invoiceNumber)}
                                helperText={formik.touched.invoiceNumber && formik.errors.invoiceNumber}
                                StartIcon={FaHashtag}
                                isDisabled={isDisabled}
                            />
                        </div>
                    </div>
                </Grid>

                {/* Amount Field */}
                <Grid item xs={12} md={6}>
                    <div className="invoice-form-mid-container">
                        <div className="invoice-label-container">
                            <span className="invoice-label">
                                Amount (AED)<span className="invoice-required-remark">*</span>
                            </span>
                        </div>
                        <div className="invoice-custom-textfield-container">
                            <CustomTextFieldWithIcon
                                id="amount"
                                name="amount"
                                placeholder="Enter AED amount"
                                type="number"
                                value={formik?.values?.amount}
                                // onChange={formik.handleChange}
                                onChange={(e) => {
                                    const val = e.target.value;

                                    // Regex: 1 to 7 digits, optional decimal with up to 2 digits
                                    const regex = /^\d{0,7}(\.\d{0,2})?$/;

                                    if (val.length <= 10 && regex.test(val)) {
                                        formik.setFieldValue('amount', val);
                                    }
                                }}

                                onBlur={formik.handleBlur}
                                error={formik.touched.amount && Boolean(formik.errors.amount)}
                                helperText={formik.touched.amount && formik.errors.amount}
                                isDisabled={isDisabled}
                            />
                        </div>
                    </div>
                </Grid>

                {/* Description Field */}
                <Grid item xs={12}>
                    <div className="invoice-form-mid-container">
                        <div className="invoice-label-container">
                            <span className="invoice-label">
                                Description
                                <span className="invoice-required-remark">*</span>
                            </span>
                        </div>
                        <div className="invoice-custom-textfield-container">
                            <CustomTextArea
                                id="description"
                                name="description"
                                placeholder="Enter description"
                                value={formik?.values?.description}
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                                rows={5}
                                error={formik.touched.description && Boolean(formik.errors.description)}
                                helperText={formik.touched.description && formik.errors.description}
                                isDisabled={isDisabled}
                            />
                        </div>
                    </div>
                </Grid>
            </Grid>

            {!isDisabled && (
                <div className="invoice-form-bottom-action-buttons-container">
                    <ActionButton onClick={handleReset} label="Reset" btnType="outlined" />
                    <ActionButton
                        onClick={() => formik.handleSubmit()}
                        btnDisable={isButtonDisabled}
                        label="Save"
                        btnType="primary"
                    />
                </div>
            )}
        </div>
    );
}

export default InvoiceForm;
